import type { EditorAPI } from '#packages/editorAPI';
import type { Callback } from '@wix/document-services-types';
import experiment from 'experiment';

interface Message {
  data: {
    value: string;
    scope: string;
    key?: string;
    keys?: string[];
  };
  compId: string;
}

const setValue = function (
  editorAPI: EditorAPI,
  msg: Message,
  callback: Callback,
) {
  if (!msg.compId) {
    // install pricing plans -> open settings -> go to preview
    // while going to preview, component is deselected, so compId of tpaSettings gets replaced to undefined
    // given no compId means no compRef, and a failure in DS
    console.warn('an attempt to set tpa data without compId: ', msg);
    return;
  }

  const compPointer = editorAPI.components.get.byId(msg.compId);
  // @ts-expect-error
  editorAPI.dsActions.tpa.data.set(
    compPointer,
    msg.data.key,
    msg.data.value,
    msg.data.scope,
    callback,
  );
};

const getValue = function (
  editorAPI: EditorAPI,
  msg: Message,
  callback: Callback,
) {
  // @ts-expect-error
  if (msg.data.scope === editorAPI.dsRead.tpa.data.SCOPE.APP) {
    const origCompData = editorAPI.selection.getSelectedComponentData() || {};
    if (experiment.isOpen('se_appDefIdUpdates')) {
      editorAPI.dsRead.tpaV2.data.app.get(
        origCompData.appDefId,
        msg.data.key,
        callback,
      );
    } else {
      // @ts-expect-error
      editorAPI.dsRead.tpa.data.app.get(
        origCompData.applicationId,
        msg.data.key,
        callback,
      );
    }
  } else {
    const compPointer = editorAPI.components.get.byId(msg.compId);
    // @ts-expect-error
    editorAPI.dsRead.tpa.data.comp.get(compPointer, msg.data.key, callback);
  }
};

const removeValue = function (
  editorAPI: EditorAPI,
  msg: Message,
  callback: Callback,
) {
  const compPointer = editorAPI.components.get.byId(msg.compId);
  // @ts-expect-error
  editorAPI.dsActions.tpa.data.remove(
    compPointer,
    msg.data.key,
    msg.data.scope,
    callback,
  );
};

const getValues = function (
  editorAPI: EditorAPI,
  msg: Message,
  callback: Callback,
) {
  // @ts-expect-error
  if (msg.data.scope === editorAPI.dsRead.tpa.data.SCOPE.APP) {
    const origCompData = editorAPI.selection.getSelectedComponentData();
    if (experiment.isOpen('se_appDefIdUpdates')) {
      editorAPI.dsRead.tpaV2.data.app.getMulti(
        origCompData.appDefinitionId,
        msg.data.keys,
        callback,
      );
    } else {
      // @ts-expect-error
      editorAPI.dsRead.tpa.data.app.getMulti(
        origCompData.applicationId,
        msg.data.keys,
        callback,
      );
    }
  } else {
    const compPointer = editorAPI.components.get.byId(msg.compId);
    // @ts-expect-error
    editorAPI.dsRead.tpa.data.comp.getMulti(
      compPointer,
      msg.data.keys,
      callback,
    );
  }
};

export { setValue, removeValue, getValue, getValues };
